import { KatStatusindicator } from "@amzn/katal-react";
import classNames from "classnames";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  type StatusIndicator,
  type ValidationGroup,
  ValidationGroupStatus,
} from "src/api/interfaces/document_validation";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";
import styles from "src/styles.module.scss";
import { getTranslatedValue } from "src/utils";

const INFO_TYPE = "information";
const SUCCESS_TYPE = "success";
const PENDING_TYPE = "pending";
const ERROR_TYPE = "error";

const VALIDATION_GROUP_STATUS_TO_STATUS_INDICATOR_TYPE: Map<
  string,
  StatusIndicator
> = new Map([
  [
    ValidationGroupStatus.CRITICAL.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_critical },
  ],
  [
    ValidationGroupStatus.ERROR.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [
    ValidationGroupStatus.INFO.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_information },
  ],
  [
    ValidationGroupStatus.SEVERE_ERROR.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [ValidationGroupStatus.PENDING.valueOf(), { statusType: PENDING_TYPE }],
  [ValidationGroupStatus.SKIPPED.valueOf(), { statusType: INFO_TYPE }],
  [ValidationGroupStatus.SUCCESS.valueOf(), { statusType: SUCCESS_TYPE }],
]);

const ValidationGroupStatusIndicator: FC<
  ValidationGroupStatusIndicatorProps
> = ({ content, translateValue }) => {
  const { t } = useTranslation();
  const validationGroupStatusText = content.validationGroupStatus.valueOf();
  const translatedValidationGroupStatusText = translateValue
    ? getTranslatedValue(validationGroupStatusText, t)
    : validationGroupStatusText;

  const statusIndicatorType: StatusIndicator =
    VALIDATION_GROUP_STATUS_TO_STATUS_INDICATOR_TYPE.get(
      validationGroupStatusText
    ) || { statusType: INFO_TYPE };

  return (
    <KatStatusindicator
      label={translatedValidationGroupStatusText}
      variant={statusIndicatorType.statusType}
      className={classNames(styles.capitalizedText, statusIndicatorType?.style)}
    />
  );
};

export type ValidationGroupStatusIndicatorProps =
  DataTableCellChildComponentProps<ValidationGroup>;

export default ValidationGroupStatusIndicator;
